import { BreadcrumbItem } from "components/core/Breadcrumbs/Breadcrumb";
import { buildListPageUrl } from "helpers/redirectUtilities";
import { isNullEmptyOrWhitespace } from "helpers/stringUtilities";
import { useActiveMenu } from "hooks/useActiveMenu";
import { useFarmGetMany } from "hooks/useFarm";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

export default function BreadcrumbItemMenu({ farm, ...other }) {
  const navigate = useNavigate();
  const { activeMenu } = useActiveMenu();

  const { data: farms } = useFarmGetMany();

  const distinctFarmGroupCount = useMemo(() => {
    const farmGroupsSet = new Set();
    for (const farm of farms) {
      const farmGroup = farm.FarmGroup?.toLowerCase();
      if (farmGroup) {
        farmGroupsSet.add(farmGroup);
      }
    }

    return farmGroupsSet.size;
  }, [farms]);

  const menuFilteredByMeta = useMemo(() => {
    let result = {};

    if (!isNullEmptyOrWhitespace(farm?.FarmGroup)) {
      result["Group"] = [farm.FarmGroup];
    }

    return result;
  }, [farm]);

  //#region Side effects

  //#endregion

  //#region Event handlers

  const handleClickMenu = (menu) => {
    return navigate(buildListPageUrl(menu));

    // TODO: trigger refresh of form values for formType in URL
  };

  //#endregion

  if (activeMenu?.Metadata?.breadcrumb?.showMenu === false) {
    return null;
  }

  return (
    <BreadcrumbItem
      {...other}
      title={activeMenu?.Title}
      subtitle="Menu"
      showDivider={false}
      loaded={activeMenu?.Parent?.Children?.length > 0}
      options={
        activeMenu?.Parent?.Children?.length > 1
          ? activeMenu.Parent.Children.map((m) => {
              const meta = {};
              if (!isNullEmptyOrWhitespace(m.Metadata.farmgroups)) {
                meta.Group = m.Metadata.farmgroups;
              }

              return {
                id: m.ID,
                text: (
                  <div className="font-medium text-primary mr-3">{m.Title}</div>
                ),
                onClick: () => handleClickMenu(m),
                meta,
              };
            })
          : []
      }
      optionsHeading={<div className="text-lg font-medium">Menu</div>}
      optionsFilteredByMeta={distinctFarmGroupCount > 1 ? menuFilteredByMeta : null}
    />
  );
}
